import React from "react";
import LegalShell from "./LegalShell";

export default function MentionsLegales() {
  return (
    <LegalShell
      title="Mentions légales"
      subtitle="Informations légales relatives à l'éditeur du site DepannRoute, conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 (LCEN)."
      lastUpdate="19 février 2026"
      canonical="https://depannroute.com/mentions-legales"
    >
      <h2>1. Éditeur du site</h2>
      <p>
        Le site <strong>DepannRoute</strong> (ci-après « le Site ») est édité par :
      </p>
      <ul>
        <li><strong>Raison sociale :</strong> [À REMPLIR — ex : DEPANNROUTE SAS]</li>
        <li><strong>Forme juridique :</strong> [À REMPLIR — ex : Société par Actions Simplifiée]</li>
        <li><strong>Capital social :</strong> [À REMPLIR] €</li>
        <li><strong>Siège social :</strong> [À REMPLIR — adresse complète]</li>
        <li><strong>SIREN :</strong> [À REMPLIR]</li>
        <li><strong>SIRET :</strong> [À REMPLIR]</li>
        <li><strong>RCS :</strong> [À REMPLIR — ex : Paris B 000 000 000]</li>
        <li><strong>N° TVA intracommunautaire :</strong> [À REMPLIR — ex : FR00 000000000]</li>
        <li><strong>Directeur de la publication :</strong> [À REMPLIR — nom et prénom]</li>
        <li><strong>Email :</strong> contact@depannroute.com</li>
        <li><strong>Téléphone :</strong> [À REMPLIR]</li>
      </ul>

      <h2>2. Hébergeur</h2>
      <ul>
        <li><strong>Raison sociale :</strong> [À REMPLIR — hébergeur]</li>
        <li><strong>Adresse :</strong> [À REMPLIR — adresse de l'hébergeur]</li>
        <li><strong>Site web :</strong> [À REMPLIR]</li>
      </ul>

      <h2>3. Activité & nature du service</h2>
      <p>
        DepannRoute exploite une <strong>plateforme de mise en relation</strong> entre particuliers/entreprises
        ayant besoin d'un service de dépannage automobile (remorquage, transport de véhicules) et
        des professionnels du dépannage auto (ci-après les « Dépanneurs ») disposant d'une
        habilitation et d'une assurance professionnelle valides.
      </p>
      <p>
        DepannRoute <strong>n'effectue pas elle-même</strong> les prestations de dépannage. Elle perçoit
        une commission sur chaque mission facturée via la plateforme.
      </p>

      <h2>4. Propriété intellectuelle</h2>
      <p>
        L'ensemble des éléments du Site (textes, illustrations, logos, logiciels, bases de données,
        algorithmes de matching) sont la propriété exclusive de DepannRoute ou de ses partenaires,
        et sont protégés par le Code de la propriété intellectuelle. Toute reproduction,
        représentation, modification, publication, adaptation, totale ou partielle, par quelque
        procédé que ce soit, est interdite, sauf autorisation écrite préalable.
      </p>

      <h2>5. Responsabilité</h2>
      <p>
        DepannRoute met tout en œuvre pour offrir aux utilisateurs des informations et des outils
        disponibles et vérifiés. Toutefois, l'Éditeur ne saurait être tenu responsable des erreurs,
        d'une absence de disponibilité des informations ou de la présence de virus sur le Site.
      </p>
      <p>
        La plateforme joue un rôle d'intermédiaire technique. Les litiges éventuels relatifs à
        l'exécution d'une mission de dépannage relèvent de la relation contractuelle directe entre
        le Client et le Dépanneur.
      </p>

      <h2>6. Médiation de la consommation</h2>
      <p>
        Conformément aux articles L.611-1 et suivants du Code de la consommation, le consommateur a
        le droit de recourir gratuitement à un médiateur de la consommation :
      </p>
      <ul>
        <li><strong>Médiateur désigné :</strong> [À REMPLIR — ex : CNPM Médiation Consommation]</li>
        <li><strong>Adresse :</strong> [À REMPLIR]</li>
        <li><strong>Site web :</strong> [À REMPLIR]</li>
      </ul>
      <p>
        Plateforme européenne de règlement en ligne des litiges (RLL) :{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
          ec.europa.eu/consumers/odr
        </a>
      </p>

      <h2>7. Droit applicable</h2>
      <p>
        Le présent Site est soumis au <strong>droit français</strong>. Tout litige relatif à son
        utilisation relève de la compétence des tribunaux français, sous réserve des règles
        particulières de compétence applicables aux consommateurs.
      </p>

      <h2>8. Contact</h2>
      <p>
        Pour toute question : <a href="mailto:contact@depannroute.com">contact@depannroute.com</a>
      </p>
    </LegalShell>
  );
}
